import { Database, Model, Q } from '@nozbe/watermelondb';
import { isEmpty } from 'lodash';

import { Location, LocationModel } from '../../../../types/Location';
import { ValidationOperation } from '../../../validation/validator';

export type UserEntityTableName = 'users' | 'locations';

export type PreparedUserData = {
    record: Model;
    table: UserEntityTableName;
    operation: ValidationOperation;
};

export const mapRecord = (
    record: Model,
    table: UserEntityTableName,
    operation: ValidationOperation,
): PreparedUserData => ({
    record,
    table,
    operation,
});

export const addPreparedDataBatch = async (
    preparedData: PreparedUserData[],
    database: Database,
) => {
    await database.batch(...preparedData.map(({ record }) => record));
};

export const prepareUserLocation = async ({
    location,
    userId,
    organisationID,
    database,
}: {
    location?: Location;
    userId: string;
    organisationID: string;
    database: Database;
}): Promise<{
    preparedLocation?: LocationModel;
    existingLocation?: LocationModel;
}> => {
    if (!location || isEmpty(location) || !location.placeId) return {};

    const locationCollection =
        database.collections.get<LocationModel>('locations');

    const existingLocations = await locationCollection
        .query(Q.where('place_id', location.placeId))
        .fetch();

    if (existingLocations.length > 0) {
        return { existingLocation: existingLocations[0] };
    }

    const preparedLocation = locationCollection.prepareCreate((loc) => {
        loc.placeId = location.placeId;
        loc.name = location.name;
        loc.lat = `${location.lat}`;
        loc.lng = `${location.lng}`;
        loc.url = location.url;
        loc.utcOffset = location.utcOffset;
        loc.userId = userId;
        loc.organisationId = organisationID;
    });

    return { preparedLocation };
};
